/**
 * Menu Drawer Submenu Positioning Script
 * Ensures submenus are properly positioned and visible
 * Handles mobile full-screen submenu navigation
 */

document.addEventListener('DOMContentLoaded', function() {
  const menuItems = document.querySelectorAll('.menu-drawer__item--has-submenu');
  const isMobile = window.innerWidth <= 749;
  
  // console.log('Submenu script loaded. Found', menuItems.length, 'menu items with submenus');
  // console.log('Mobile mode:', isMobile);
  
  menuItems.forEach((item, index) => {
    const submenu = item.querySelector('.menu-drawer__submenu');
    const itemLink = item.querySelector('.menu-drawer__item-link');
    
    if (!submenu) {
      console.warn('No submenu found for item', index);
      return;
    }
    
    // console.log('Setting up submenu', index, submenu);
    
    // Desktop: Ensure submenu is positioned correctly
    if (!isMobile) {
      submenu.style.position = 'fixed';
      submenu.style.left = '280px';
      submenu.style.top = '0';
      submenu.style.bottom = '0';
      submenu.style.right = '0';
      
      // Add hover event listeners for debugging
      item.addEventListener('mouseenter', function() {
        // console.log('Mouse entered item', index);
        // console.log('Submenu visibility:', window.getComputedStyle(submenu).visibility);
        // console.log('Submenu opacity:', window.getComputedStyle(submenu).opacity);
      });
      
      item.addEventListener('mouseleave', function() {
        // console.log('Mouse left item', index);
      });
    } else {
      // Mobile: Click to open full-screen submenu
      if (itemLink) {
        itemLink.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          // console.log('Mobile: Opening submenu', index);
          item.classList.add('active');
          document.body.style.overflow = 'hidden';
        });
      }
      
      // Back button functionality
      const backButton = submenu.querySelector('.mega-menu__back-button');
      if (backButton) {
        backButton.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          // console.log('Mobile: Closing submenu', index);
          item.classList.remove('active');
          document.body.style.overflow = '';
        });
      }
    }
  });
  
  // Handle window resize
  let resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() {
      const newIsMobile = window.innerWidth <= 749;
      if (newIsMobile !== isMobile) {
        location.reload();
      }
    }, 250);
  });
});
